import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'boels-vertical-aligner',
  templateUrl: './vertical-aligner.component.html',
  imports: [NgClass],
  styleUrls: ['./vertical-aligner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalAlignerComponent {
  /**
   * When to use vertical-aligner component?
   * The vertical-aligner component is used to vertically align content within a
   * page or component that needs to align vertically with the page.
   * An example is the header component that needs to be vertically aligned with the page.
   */

  /**
   * The innerWidth property is used to set the width of the vertical-aligner component.
   * A default value is set. There is an option to choose `full`.
   * This will set the width to 100%.
   */
  @Input() innerWidth: 'wide' | 'default' | 'full' = 'default';

  @HostBinding('class') get classes(): string {
    return `boels-vertical-aligner--inner-width--${this.innerWidth}`;
  }
}
